import { Avatar, Box, Container, Grid, Stack, Typography } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';
import { getInitialsFromName } from '@/ui/utils/initials-from-name';

import { ExternalFormInfos } from './ExternalFormInfos';

export function Layout({
  children,
  userName,
}: {
  children: React.ReactNode;
  userName: string;
}) {
  return (
    <Container maxWidth="lg">
      <Box>
        <Box sx={{ py: 4, px: 2 }}>
          <Stack>
            <Username userName={userName} />
            <Box sx={{ py: 2 }}>
              <Grid container spacing={4} sx={{ height: '100%' }}>
                <Grid item sm={5} sx={{ height: '100%' }}>
                  <ExternalFormInfos />
                </Grid>
                <Grid item sm={7} alignSelf={'center'} sx={{ width: '100%' }}>
                  {children}
                </Grid>
              </Grid>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
}

function Username({ userName }: { userName: string }) {
  if (!userName) {
    return <></>;
  }
  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Avatar
        sx={{
          bgcolor: ColorsRaw.basic.Cream,
          color: ColorsRaw.anthracite.Warm_Anthracite,
          fontSize: '16px',
          mr: 1,
          fontWeight: '600',
        }}
      >
        {getInitialsFromName(userName)}
      </Avatar>
      <Typography
        sx={{
          fontSize: '1rem',
          fontWeight: '400',
        }}
      >
        {userName}
      </Typography>
    </Stack>
  );
}
